import React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import theme from "../../../theme/Theme";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";

export const ASTERISK_ELEMENT = (<span style={{ color: "#42A45C" }}>*</span>);

export const SELECTION_COLOR = {
  color: theme.palette.artisticGrey300.main,
  '&.Mui-checked': {
    color: theme.palette.artisticGrey300.main,
  },
}

export const CqaFormTextInput = styled(OutlinedInput)`
  &.MuiOutlinedInput-root {
    input {
      padding: 8px 16px;
    }

    & fieldset {
      border: 1px solid ${theme.palette.artisticStroke200.main};
    }

    &:hover fieldset {
      border: 1px solid ${theme.palette.artisticGrey400.main};
    }

    &.Mui-focused fieldset {
      border: 1px solid ${theme.palette.artisticGrey400.main};
    }
  }
`;

export const CqaFormTextArea = styled(TextField)`
  & .MuiOutlinedInput-root {
      align-items: start;
      padding: 8px 16px;
      height: 80px;
      angle: 0 deg;
      opacity: 1;
      border-radius: 4px;
      padding-top: 8px;
      padding-bottom: 8px;

    & fieldset {
      border: 1px solid ${theme.palette.artisticStroke200.main};
    }

    &:hover fieldset {
      border: 1px solid ${theme.palette.artisticGrey400.main};
    }

    &.Mui-focused fieldset {
      border: 1px solid ${theme.palette.artisticGrey400.main};
    }
  }
`;

export const DROPDOWN_STYLE = {
  height: "32px",
  width: "160px",
  borderRadius: "3px",

  "& .MuiSelect-select": {
    paddingRight: "16px !important",
  },
  "& .MuiSelect-icon": {
    color: theme.palette.artisticTextInteractive.main,
  },
  "& .MuiOutlinedInput-notchedOutline": {
    border: `1px solid ${theme.palette.artisticStroke200.main} !important`,
  },
  "&.Mui-focused fieldset": {
    border: `1px solid ${theme.palette.artisticGrey400.main} !important`,
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: `${theme.palette.artisticGrey400.main} !important`,
  },
};

export const PLACEHOLDER_STYLE = {
  "& .MuiInputBase-input::placeholder": {
    color: theme.palette.artisticTextLow.main,
    opacity: 1,
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: "16px",
  }
}